module.exports = __webpack_public_path__ + "img/case.9ad99e98.png";